var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSetting(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 45,
    viewBox: "0 0 41 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1978 29.9099C24.34 29.9099 27.6978 26.5521 27.6978 22.4099C27.6978 18.2676 24.34 14.9099 20.1978 14.9099C16.0555 14.9099 12.6978 18.2676 12.6978 22.4099C12.6978 26.5521 16.0555 29.9099 20.1978 29.9099ZM20.1978 32.4099C25.7205 32.4099 30.1978 27.9326 30.1978 22.4099C30.1978 16.887 25.7205 12.4099 20.1978 12.4099C14.6749 12.4099 10.1978 16.887 10.1978 22.4099C10.1978 27.9326 14.6749 32.4099 20.1978 32.4099Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.9721 11.9052C3.1849 12.348 2.69775 13.1809 2.69775 14.0841V30.7356C2.69775 31.6389 3.1849 32.4719 3.9721 32.9146L18.972 41.3521C19.7333 41.7801 20.6623 41.7801 21.4235 41.3521L36.4235 32.9146C37.2105 32.4719 37.6978 31.6389 37.6978 30.7356V14.0841C37.6978 13.1809 37.2105 12.348 36.4235 11.9052L21.4235 3.46767C20.6623 3.03957 19.7333 3.03957 18.972 3.46767L3.9721 11.9052ZM22.649 1.28872C21.127 0.432569 19.2685 0.432569 17.7465 1.28872L2.74645 9.72622C1.17205 10.6118 0.197754 12.2777 0.197754 14.0841V30.7356C0.197754 32.5419 1.17205 34.2079 2.74645 35.0936L17.7465 43.5311C19.2685 44.3871 21.127 44.3871 22.649 43.5311L37.649 35.0936C39.2235 34.2079 40.1978 32.5419 40.1978 30.7356V14.0841C40.1978 12.2777 39.2235 10.6118 37.649 9.72622L22.649 1.28872Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting);
export default __webpack_public_path__ + "static/media/setting.633f6fec660fb3e2a41566d114dd489f.svg";
export { ForwardRef as ReactComponent };